import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (p1113)
// ============================================================

export interface F113 {
  f113_01: string;   // 原料代號 (PK1)
  f113_02: string;   // 工繳代號 (PK2)
  f113_11: string;   // 產品名稱
  f113_12: string;   // 單位
  f113_13: string | null; // 日期
  f113_14: number;
  f113_15: number;
  f113_16: number;
  f113_17: number;
  f113_18: string;   // 圖片 URL
  f113_19: string;   // 單位類別
  f113_20: string;   // 加工別
  f113_21: string;   // 產品規格
  f113_22: number;   // 有效幅寬
  f113_24: number;   // 米平方重
  f113_241: number;  // 米平方重(±)
  f113_26: number;   // 針孔外幅寬
  f113_28: string;   // 商業代號
  f113_29: number;   // 產品類型
  f113_30: string;   // 產品全名(唯讀)
  f113_31: boolean;  // 舊代號
  f113_32: number;   // 客戶對應計數
  f113_33: number;   // 材料成分計數
  f113_34: number;   // 規格分類計數
  f113_39: boolean;  // 代購
  f113_35: string;   // 建檔人員
  f113_36: string | null; // 建檔日期
  f113_27: string;   // 產品類別
  f113_37: boolean;  // 布林旗標
  f113_38: number;   // 數值(6,1)
  f113_46: number;   // 產品類型細項
  f113_91: string;   // 修改人員
  f113_92: string | null; // 修改日期
  f113_93: string;   // 修改時間
  // 商業代號欄位
  f113_411: string;
  f113_412: string;
  f113_413: string;
  f113_414: string;
  f113_415: string;
  f113_416: number;
  f113_417: number;
  f113_418: number;
  f113_419: number;
  f113_421: string;
  f113_43: number;
  // Associations
  customer_codes?: F1131[];
  compositions?: F1132[];
  spec_classes?: F1133[];
  garment_sizes?: F1134[];
  inspection_specs?: F1135[];
}

export interface F1131 {
  f1131_01: string; f1131_02: string; f1131_03: string; f1131_04: string;
}

export interface F1132 {
  f1132_01: string; f1132_02: string; f1132_03: number; f1132_11: string;
}

export interface F1133 {
  f1133_01: string; f1133_02: string; f1133_03: number; f1133_11: string;
}

export interface F1134 {
  f1134_01: string; f1134_02: string; f1134_03: number; f1134_11: string;
}

export interface F1135 {
  f1135_01: string; f1135_02: string; f1135_03: number;
  f1135_11: string; f1135_12: string; f1135_13: string;
  f1135_131: string; f1135_14: string; f1135_15: boolean;
}

export interface ListResponse {
  data: F113[]; total: number; page: number; size: number;
}

export interface ProductCreateRequest {
  master: Partial<F113>;
  customer_codes?: F1131[];
  compositions?: F1132[];
  spec_classes?: F1133[];
  garment_sizes?: F1134[];
  inspection_specs?: F1135[];
}

export interface ProductUpdateRequest {
  master: Partial<F113>;
  customer_codes?: F1131[];
  compositions?: F1132[];
  spec_classes?: F1133[];
  garment_sizes?: F1134[];
  inspection_specs?: F1135[];
}

export interface ImageUploadResponse {
  url: string;
  fileId: string;
  fileName: string;
  fileSize: number;
}

export const p1113Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/product', { params });
    return res.data;
  },

  async get(pk1: string, pk2 = ''): Promise<F113> {
    const res = await apiClient.get(`/api/product/${encodeURIComponent(pk1)}`, { params: { pk2 } });
    return res.data;
  },

  async create(data: ProductCreateRequest): Promise<F113> {
    const res = await apiClient.post('/api/product', data);
    return res.data;
  },

  async update(pk1: string, pk2: string, data: ProductUpdateRequest): Promise<F113> {
    const res = await apiClient.put(`/api/product/${encodeURIComponent(pk1)}`, data, { params: { pk2 } });
    return res.data;
  },

  async delete(pk1: string, pk2 = ''): Promise<void> {
    await apiClient.delete(`/api/product/${encodeURIComponent(pk1)}`, { params: { pk2 } });
  },

  async uploadImage(file: File): Promise<ImageUploadResponse> {
    const formData = new FormData();
    formData.append('image', file);
    const res = await apiClient.post('/api/product/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000,
    });
    return res.data;
  },
};
